import { Injectable } from '@angular/core';
import { PCacheable } from 'ts-cacheable';
import { environment } from '../../environments/environment';
import { DisplayLabel } from '../models/displayLabel';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class JobTypeService {
  constructor(private readonly api: ApiService) {}

  @PCacheable()
  public async findAll(): Promise<DisplayLabel[]> {
    return this.api.get(environment.api.jobTypes);
  }
}
